import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { Link as RouterLink, useRouter } from "@tanstack/react-router";
import {
  AppBar,
  Box,
  Button,
  Container,
  Toolbar,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useAuth } from "../auth/useAuth";
import { setAuthed } from "../auth/authStore";

async function postLogout(): Promise<void> {
  await fetch("/api/auth/logout", {
    method: "POST",
    credentials: "include",
  });
}

export function Header() {
  const router = useRouter();
  const { isAuthed, initialized } = useAuth();
  const [loggingOut, setLoggingOut] = useState(false);

  async function handleLogout(): Promise<void> {
    setLoggingOut(true);
    try {
      await postLogout();
      setAuthed(false);
      await router.navigate({ to: "/auth" });
    } finally {
      setLoggingOut(false);
    }
  }

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        borderBottom: "1px solid",
        borderColor: "divider",
        background: "linear-gradient(90deg, #e6e5df, #f2f1ee)",
        backdropFilter: "blur(10px)",
        color: "text.primary",
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ py: 1, display: "flex", gap: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <FavoriteRoundedIcon sx={{ opacity: 0.85 }} />
            <Typography
              component={RouterLink}
              to="/"
              sx={{
                textDecoration: "none",
                color: "inherit",
                fontWeight: 800,
                letterSpacing: 0.2,
              }}
            >
              May &amp; Toffe
            </Typography>
          </Box>
          <Box
            sx={{ ml: "auto", display: "flex", alignItems: "center", gap: 1 }}
          >
            {initialized && isAuthed ? (
              <Button
                onClick={() => void handleLogout()}
                variant="outlined"
                size="small"
                startIcon={<LogoutRoundedIcon />}
                disabled={loggingOut}
                sx={{ textTransform: "none", borderRadius: 999 }}
              >
                {loggingOut ? "Logging out…" : "Logout"}
              </Button>
            ) : null}
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: 2 }}>
            <Button
              component={RouterLink}
              to="/"
              variant="text"
              sx={{ textTransform: "none", display: { xs: "none" } }}
            >
              Home
            </Button>
            <Button
              component={RouterLink}
              to="/info"
              variant="text"
              sx={{ textTransform: "none" }}
            >
              Info
            </Button>
            <Button
              component={RouterLink}
              to="/rsvp"
              variant="contained"
              sx={{
                textTransform: "none",
                borderRadius: 999,
                px: 2,
                boxShadow: "none",
              }}
            >
              RSVP
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
